var isNil = require('./isNil');
var isString = require('./isString');

module.exports = function isTypeName(name) {
  return isNil(name) || isString(name);
};


//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/isTypeName.js
// module id = 731
// module chunks = 0